export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40136a1a42cb94ddc6f5dcb7a7c34c77c43c204191&name=revalidateCommunity!'